import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold',
  {
    variants: {
      variant: {
        neutral: 'bg-secondary text-secondary-foreground',
        brand: 'bg-brand-muted text-brand',
        success: 'bg-success/15 text-success',
        warning: 'bg-warning/20 text-warning-foreground',
        danger: 'bg-danger/15 text-danger',
        info: 'bg-info/15 text-info',
      },
    },
    defaultVariants: { variant: 'neutral' },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

/** Farbiger Punkt + Label für Stages/Status (Monday-Stil). */
export function StatusPill({ color, label }: { color?: string | null; label: string }) {
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-xs font-semibold text-white"
      style={{ backgroundColor: color ?? '#579bfc' }}
    >
      {label}
    </span>
  );
}
